import { render, staticRenderFns } from "./pregnantDetail.vue?vue&type=template&id=77813874&scoped=true"
import script from "./pregnantDetail.vue?vue&type=script&lang=js"
export * from "./pregnantDetail.vue?vue&type=script&lang=js"
import style0 from "./pregnantDetail.vue?vue&type=style&index=0&id=77813874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77813874",
  null
  
)

export default component.exports